import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import { type Price, paymentAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

/**
 * Returns payment methods for the current country that correspond to the given listings, bag price ...
 * Prefer the use of the cached version `useMarketPaymentMethods` when possible
 *
 * @example
 * const { data: paymentMethods } = await useMarketPaymentMethodsFor({
 *  listings: ['123', '456'],
 *  bagPrice: { amount: '99.99', currency: 'EUR' },
 * })
 */
export const useMarketPaymentMethodsFor = ({
  listings,
  bagPrice,
  hasInsurance,
}: {
  listings?: MaybeRefOrGetter<string[]>
  bagPrice?: MaybeRefOrGetter<Price>
  hasInsurance?: MaybeRefOrGetter<boolean>
}) => {
  const { market } = useMarketplace()

  return useHttpFetch(paymentAPI.getMethods, {
    queryParams: {
      country_code: market.countryCode,
      listings: computed(() => toValue(listings)?.join(',')),
      bag_price: computed(() => toValue(bagPrice)?.amount),
      insurance_subscription: hasInsurance,
    },
    transform: (data) => data.results,
  })
}
